import Vue from 'vue'
import App from './App.vue'
import router from './app/router'
import { store } from './app/store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueHotkey from 'v-hotkey'
import VueCookies from 'vue-cookies'
import VueYandexMetrika from 'vue-yandex-metrika'

Vue.use(VueHotkey)
Vue.use(VueCookies)

const baseURL = process.env.VUE_APP_SERVER_TYPE === 'local'
	? "http://rszff.lh"
	: process.env.NODE_ENV === "production"
		? "https://video.roasup.com"
		: "https://video-dev.roasup.com";
Vue.prototype.$buildType = process.env.NODE_ENV;//process.env.VUE_APP_BUILD_TYPE ? process.env.VUE_APP_BUILD_TYPE : process.env.NODE_ENV;
Vue.prototype.$baseURL = baseURL;

Vue.use(VueAxios, axios.create({
	baseURL: baseURL + '/api'
}));
Vue.config.productionTip = false;

export const $eventsBus = new Vue();

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
